import useSWR from 'swr'

import {
  AuthenticationCredentialFetcher,
  CreateRefreshToken,
  GetAccountAvailabilityFetcher,
  GetCurrentUserFetcher,
  GetUsersFetcher,
  GetUserVehicles,
  InviteUserFetcher,
  LoginFetcher,
  OtpVerifyFetcher,
  PolicyFetcher,
  SignUpFetcher,
  SignUpV2Fetcher,
  UpdateCurrentTenantInvoiceFetcher,
  UpdateCurrentUserFetcher,
  UpdateOnboardingFetcher,
  ForgotPasswordFetcher,
  ConfirmSignUpFetcher,
  AuthenticationMethodFetcher,
  ConfirmForgotPasswordFetcher,
  ResendEmailConfirmationFetcher,
} from './TenantServiceFetchers'

export enum TenantServicePath {
  GetCurrentUser = '/carrier/users/current',
  GetAccountAvailability = '/users/accountAvailability',
  InviteUser = '/carrier/users/invite',
  Login = '/carrier/users/login',
  OtpVerify = '/carrier/users/loginVerify',
  Policy = '/carrier/users/policy',
  RefreshToken = '/users/refreshToken',
  SignUp = '/carrier/users/signup',
  SignUpV2 = '/carrier/users/signup',
  UpdateOnboarding = '/carrier/onboarding',
  Users = '/carrier/users',
  Vehicles = '/carrier/vehicles',
  Invoice = '/carrier/invoice',
  AuthenticationCredential = '/users/authenticationCredential',
  ForgotPassword = '/users/forgotPassword',
  ConfirmSignup = '/users/confirmSignup',
  AuthenticationMethod = '/users/authenticationMethod',
  ConfirmForgotPassword = '/users/confirmForgotPassword',
  ResendEmailConfirmation = '/users/resendCode',
}

export default {
  getCurrentUser: (revalidateOnMount = true, revalidateIfStale = true) =>
    useSWR(TenantServicePath.GetCurrentUser, GetCurrentUserFetcher, {
      revalidateOnMount,
      revalidateIfStale,
    }),
  getUsers: (query: string, revalidateOnMount = true) =>
    useSWR([TenantServicePath.Users, query], GetUsersFetcher, {
      revalidateOnMount,
    }),
  getVehicles: (query: string, revalidateOnMount = true) =>
    useSWR([TenantServicePath.Vehicles, query], GetUserVehicles, {
      revalidateOnMount,
    }),
  GetAccountAvailabilityFetcher,
  CreateRefreshToken,
  InviteUserFetcher,
  LoginFetcher,
  OtpVerifyFetcher,
  PolicyFetcher,
  SignUpFetcher,
  SignUpV2Fetcher,
  UpdateCurrentTenantInvoiceFetcher,
  UpdateCurrentUserFetcher,
  UpdateOnboardingFetcher,
  AuthenticationCredentialFetcher,
  ForgotPasswordFetcher,
  ConfirmSignUpFetcher,
  AuthenticationMethodFetcher,
  ConfirmForgotPasswordFetcher,
  ResendEmailConfirmationFetcher,
}
